import { useSelector } from 'react-redux';

type UseCartLockedReturn = {
  isCartLocked: boolean;
};

export const useCartLocked = (bookingId?: string): UseCartLockedReturn => {
  const isCartLocked = useSelector((state) => {
    const cartBookings = state.memberSpace.cart?.data?.bookingsCart?.cartBookings || [];

    if (bookingId) {
      const cartBooking = cartBookings.find((booking) => booking.bookingId === bookingId) || {};
      return !!cartBooking.hasServicesInOption;
    }

    return false;
  });

  return { isCartLocked };
};
